import React, { useEffect } from 'react'
import { useWebSocketContext } from '../../providers/WebSocketContextProvider';
import { useOrganListenerContext } from '../../providers/OrganListenerContextProvider';
import useWebSocketCaller from '../../hooks/useWebSocketCaller';
import { apiGetTeamInfo } from '../../hooks/useOrganListener';
import { useOperatorContext } from '../login/OperatorContextProvider';
import './TeamBox.css'

const withComma = (str) => str ? `${str}, ` : '';

const TeamBox = () => {
  const {operator}                          = useOperatorContext();
  const {isWebSocketReady, webSocketState}  = useWebSocketContext();
  const {sendMessage}                       = useWebSocketCaller();
  const {myTeamData}                        = useOrganListenerContext();
  
  useEffect(()=>{
    if (isWebSocketReady()) {
      sendMessage(apiGetTeamInfo, ({
        'teamId': operator.selectedTeamId,
        'username': operator.username,
        'accountId': operator.accountId
      }));
    }
  }, [webSocketState, isWebSocketReady, sendMessage, operator?.selectedTeamId, operator?.username, operator?.accountId]);

  // ------ Render ------

  const teamName = withComma(myTeamData?.name);

  return (
    <div className='teamBox'>
      {teamName}
    </div>
  )
}

export default React.memo(TeamBox);